export default "__VITE_ASSET__DgQuoErG__"